/* eslint-disable react/jsx-no-bind */
import React from 'react';
import PropTypes from 'prop-types';
import { useSnapshot } from 'valtio';

import Overlay from '../overlays';
import SwitchRounded from '../switch_rounded';

import { layersStore, lightStore, spacecraftStore } from '../../managers/globalState';

import SettingSVG from '../../../www/assets/images/gear.svg';

import '../../../www/assets/css/overlays/settings.css';
import ar from '../../languages/ar';

const TITLE_TEXT = ar.settings;

/**
 * Vitals Overlay component
 */
const SettingsOverlay = ({ scene, pioneer, closeOverlay, isMobile = false }) => {
	const { cityNames, groundTracks } = useSnapshot(layersStore.state);
	const { showingAllSC } = spacecraftStore.stateSnapshot;
	const { fill } = useSnapshot(lightStore.state);

	// Only show ground tracks option if a single spacecraft is in view - whether in s/c view or vital sign view
	const showGroundTracksToggle = !showingAllSC;

	return (
		<Overlay type='settings'>
			<Overlay.Header
				back
				onClose={closeOverlay}
				isMobile={isMobile}
				title={TITLE_TEXT}
				Icon={SettingSVG}
			/>
			<div className='settings'>
				<div className='item'>
					<span>{ar.lighting}</span>
					<SwitchRounded
						title={fill ? ar.on : ar.off} checked={fill} onChange={e => {
							lightStore.setGlobalState({ fill: e.target.checked });
						}}
					/>
				</div>

				<div className='item'>
					<span>{ar.city_names}</span>
					<SwitchRounded
						title={cityNames ? ar.on : ar.off} checked={cityNames} onChange={e => {
							layersStore.setGlobalState({ cityNames: e.target.checked });
						}}
					/>
				</div>

				{
					showGroundTracksToggle
					&& (
						<div className='item'>
							<span>{ar.display_ground_tracks}</span>
							<SwitchRounded
								title={groundTracks ? ar.on : ar.off} checked={groundTracks} onChange={e => {
									layersStore.setGlobalState({ groundTracks: e.target.checked });
								}}
							/>
						</div>
					)
				}

			</div>
		</Overlay>
	);
};

SettingsOverlay.propTypes = {
	isMobile: PropTypes.bool,
	scene: PropTypes.shape({
		get: PropTypes.func.isRequired
	}).isRequired,
	pioneer: PropTypes.shape({
		getScene: PropTypes.func.isRequired,
		getNumScenes: PropTypes.func.isRequired
	}).isRequired,
	closeOverlay: PropTypes.func.isRequired
};

export default SettingsOverlay;
